import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

export const formatDateTime = (date) => {
  return new Date(date).toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatPrice = (price) => {
  return new Intl.NumberFormat('fr-CA', {
    style: 'currency',
    currency: 'CAD',
  }).format(price);
};

export const getStatusLabel = (status) => {
  const labels = {
    pending: 'En attente',
    accepted: 'Acceptée',
    rejected: 'Refusée',
    completed: 'Terminée',
    cancelled: 'Annulée',
  };
  return labels[status] || status;
};

export const getStatusClass = (status) => {
  const classes = {
    pending: 'status-pending',
    accepted: 'status-accepted',
    rejected: 'status-rejected',
    completed: 'status-completed',
    cancelled: 'status-cancelled',
  };
  return classes[status] || '';
};

export const getCategoryIcon = (categoryKey) => {
  const icons = {
    batiment: 'building',
    reparation: 'wrench',
    artisanat: 'hammer',
    nature: 'leaf',
    services: 'scissors',
    transport: 'truck',
    securite: 'shield',
    creatif: 'palette',
  };
  return icons[categoryKey] || 'briefcase';
};

export const getCategoryImage = (categoryKey) => {
  const images = {
    batiment: 'https://images.pexels.com/photos/5493672/pexels-photo-5493672.jpeg',
    reparation: 'https://images.pexels.com/photos/257736/pexels-photo-257736.jpeg',
    artisanat: 'https://images.pexels.com/photos/5493669/pexels-photo-5493669.jpeg',
    nature: 'https://images.pexels.com/photos/7156462/pexels-photo-7156462.jpeg',
    services: 'https://images.pexels.com/photos/7220892/pexels-photo-7220892.jpeg',
    transport: 'https://images.unsplash.com/photo-1567506586890-37a066e5bb69',
    securite: 'https://images.pexels.com/photos/7550900/pexels-photo-7550900.jpeg',
    creatif: 'https://images.pexels.com/photos/7163458/pexels-photo-7163458.jpeg',
  };
  return images[categoryKey] || images.batiment;
};
